import { ApplicationView } from '@aha-app/mvc';
import classNames from 'classnames';
import { RECORD_ICONS } from 'javascripts/record_icons';
import React from 'react';

interface RecordIconProps {
  record: {
    typename: string;
    colorObject?: { hex?(): string } | null;
  };
}

/** Render an icon for an ApplicationModel record. If it has a color specified, the icon color will match it */
const RecordIcon: React.FC<RecordIconProps> = ({ record }) => {
  const { typename } = record;

  if (typename in RECORD_ICONS) {
    const iconStyles: React.CSSProperties = { color: 'white' };
    if (record.colorObject?.hex) {
      iconStyles.backgroundColor = record.colorObject.hex();
    }

    return (
      <i
        className={classNames(
          RECORD_ICONS[typename],
          `record-reference-pill__icon record-reference-pill__icon--${typename.toLowerCase()}`
        )}
        style={iconStyles}
      />
    );
  }

  return null;
};

export default ApplicationView(RecordIcon);
